import React, { useState } from "react";
import {
  Box,
  withStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Collapse,
  Typography,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CheckCircle from "@material-ui/icons/CheckCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import { StyledTableCell, StyledTableRow } from "./";
import { getAssignmentStatusNames } from "../helpers";
import moment from "moment";
export default function PatientAssign(props) {
  const {
    assignment,
    onClickAssign,
    index,
    operator,
    isOperator,
    showDoctorOfAssignment,
    isLab,
    handleSwitchStatus,
    handleDownloadAssignment,
    handleDownloadAssignmentWithPatientData,
  } = props;
  const [open, setOpen] = useState(false);

  // sin datos del operador,
  if (showDoctorOfAssignment) {
    return (
      <React.Fragment>
        <StyledTableRow hover>
          {/* 1 */}
          <StyledTableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </StyledTableCell>
          {/* 2 */}
          <StyledTableCell>
            {assignment?.doctor?.name} {assignment?.doctor?.lastName}
          </StyledTableCell>
          {/* 3 */}

          <StyledTableCell>{assignment?.doctor?.rut}</StyledTableCell>
          {/* 4 */}
          <StyledTableCell>{assignment.rut}</StyledTableCell>
          {/* 5 */}
          <StyledTableCell>
            {moment(assignment?.createdAt).format("DD/MM/YYYY hh:mm a")}
          </StyledTableCell>
          {/* 6 */}
          <StyledTableCell>
            {getAssignmentStatusNames(assignment.status)}
          </StyledTableCell>
        </StyledTableRow>
        <TableRow>
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, borderBottom: 0 }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  Productos asociados:
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell2>Nombre</StyledTableCell2>
                      <StyledTableCell2>Cantidad</StyledTableCell2>
                      <StyledTableCell2>Concentración</StyledTableCell2>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {assignment.products.map((product) => (
                      <TableRow hover key={product._id}>
                        <StyledTableCell2
                          style={{
                            color: index % 2 === 0 ? "#192A7F" : "#2196C0",
                          }}
                        >
                          {product.name}
                        </StyledTableCell2>
                        <StyledTableCell2
                          style={{
                            color: index % 2 === 0 ? "#192A7F" : "#2196C0",
                          }}
                        >
                          {product.requiredQuantity}
                        </StyledTableCell2>
                        <StyledTableCell2
                          style={{
                            color: index % 2 === 0 ? "#192A7F" : "#2196C0",
                          }}
                        >
                          {product.concentration}
                        </StyledTableCell2>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  // laboratorio
  if (isLab) {
    return (
      <React.Fragment>
        <StyledTableRow hover>
          {/* 1 */}
          <StyledTableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </StyledTableCell>
          {/* 2 */}
          <StyledTableCell>{operator.name}</StyledTableCell>
          {/* 4 */}
          <StyledTableCell>{assignment?.doctor?.name}</StyledTableCell>{" "}
          {/* 5 */}
          <StyledTableCell>{assignment?.doctor?.rut}</StyledTableCell>
          {/* 5 */}
          <StyledTableCell>
            {moment(assignment?.createdAt).format("DD/MM/YYYY hh:mm a")}
          </StyledTableCell>
          {/* 6 */}
          <StyledTableCell>
            {getAssignmentStatusNames(assignment.status)}
          </StyledTableCell>
        </StyledTableRow>
        <TableRow>
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, borderBottom: 0 }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  Productos asociados:
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell2>Nombre</StyledTableCell2>
                      <StyledTableCell2>Cantidad</StyledTableCell2>
                      <StyledTableCell2>Concentración</StyledTableCell2>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {assignment.products.map((product) => (
                      <TableRow hover key={product._id}>
                        <StyledTableCell2
                          style={{
                            color: index % 2 === 0 ? "#192A7F" : "#2196C0",
                          }}
                        >
                          {product.name}
                        </StyledTableCell2>
                        <StyledTableCell2
                          style={{
                            color: index % 2 === 0 ? "#192A7F" : "#2196C0",
                          }}
                        >
                          {product.requiredQuantity}
                        </StyledTableCell2>
                        <StyledTableCell2
                          style={{
                            color: index % 2 === 0 ? "#192A7F" : "#2196C0",
                          }}
                        >
                          {product.concentration}
                        </StyledTableCell2>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  // operador
  return (
    <React.Fragment>
      <StyledTableRow hover>
        {/* <StyledTableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </StyledTableCell> */}

        <StyledTableCell>
          {assignment.orderCode || "No asignado"}
        </StyledTableCell>
        <StyledTableCell>{assignment.rut}</StyledTableCell>
        <StyledTableCell>
          <Switch
            color="primary"
            defaultChecked={
              assignment.status === "66182a497b4df03548c40405" ||
              assignment.status === 1
            }
            onChange={(e) =>
              handleSwitchStatus({
                id: assignment._id,
                isDelivered: e.target.checked,
              })
            }
          />
        </StyledTableCell>
        <StyledTableCell>{`${assignment.firstName} ${assignment.lastName}`}</StyledTableCell>

        <StyledTableCell>{assignment.phone}</StyledTableCell>
        <StyledTableCell>
          {assignment.address === null
            ? "Dirección no proporcionada aún"
            : assignment.address}
        </StyledTableCell>
        <StyledTableCell>
          {getAssignmentStatusNames(assignment.status)}
        </StyledTableCell>
        <StyledTableCell>
          <IconButton
            disabled={
              assignment.status === 1 ||
              assignment.status === "66182a497b4df03548c40405"
            }
            onClick={() => onClickAssign()}
          >
            <Tooltip
              title={
                assignment.status !== 1 ||
                assignment.status !== "66182a497b4df03548c40405"
                  ? "Cambiar estado"
                  : ""
              }
              aria-label="active"
            >
              {assignment.status === 2 ||
              assignment.status === "661829ad7b4df03548c40400" ? (
                <HighlightOffIcon />
              ) : assignment.status === 3 ||
                assignment.status === "66182a037b4df03548c40403" ? (
                <AccessTimeIcon />
              ) : (
                <CheckCircle />
              )}
            </Tooltip>
          </IconButton>
          {assignment.status === 3 ||
          assignment.status === "66182a037b4df03548c40403" ? (
            <IconButton
              onClick={() => {
                handleDownloadAssignment(assignment);
              }}
            >
              <Tooltip title={"Descargar orden"} aria-label="active">
                <LocalShippingIcon />
              </Tooltip>
            </IconButton>
          ) : null}
          {assignment.status === 3 ||
          assignment.status === "66182a037b4df03548c40403" ? (
            <IconButton
              onClick={() => {
                handleDownloadAssignmentWithPatientData(assignment);
              }}
            >
              <Tooltip title={"Descargar informe"} aria-label="active">
                <AssignmentIndIcon />
              </Tooltip>
            </IconButton>
          ) : null}
        </StyledTableCell>
      </StyledTableRow>
      {/* <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, borderBottom: 0 }}
          colSpan={6}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Productos asociados:
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <StyledTableCell2>Nombre</StyledTableCell2>
                    <StyledTableCell2>Cantidad</StyledTableCell2>
                    <StyledTableCell2>Concentración</StyledTableCell2>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {assignment.products.map((product) => (
                    <TableRow hover key={product._id}>
                      <StyledTableCell2>{product.name}</StyledTableCell2>
                      <StyledTableCell2>
                        {product.requiredQuantity}
                      </StyledTableCell2>
                      <StyledTableCell2>
                        {product.concentration}
                      </StyledTableCell2>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow> */}
    </React.Fragment>
  );
}

const StyledTableCell2 = withStyles((theme) => ({
  head: {
    minWidth: 170,
  },
}))(TableCell);
